<div class="tdb" dir="rtl">

  <!-- ───────── Page Title ───────── -->
  <div class="page-title">
    <div class="page-title-heading">
      <button class="back-btn" routerLink="/" title="بازگشت"><i class="fa fa-arrow-right"></i></button>
      <div>
        <h1>داشبورد ناوگان</h1>
        <span>نمای کلی وضعیت خودروهای برقی — تله‌متری CAN</span>
      </div>
    </div>
    <div class="page-title-actions">
      <span class="live-badge"><span class="live-dot"></span> ارتباط زنده</span>
      <span class="update-badge">آخرین بروزرسانی: <strong>{{ lastUpdate }}</strong></span>
    </div>
  </div>

  <!-- ───────── Loading ───────── -->
  <div *ngIf="isLoading" class="loading-bar">
    <div class="loading-spinner"></div>
    <span>در حال دریافت اطلاعات ناوگان...</span>
  </div>

  <!-- ───────── KPI Grid (6 cards) ───────── -->
  <section class="kpi-grid">
    <div class="kpi-card" style="--accent:#3d9cff" (click)="setTableFilter('all')">
      <div class="kpi-icon">🚗</div>
      <div class="kpi-value">{{ kpi?.TotalVehicles ?? vehicles.length }}</div>
      <div class="kpi-label">کل خودروها</div>
    </div>
    <div class="kpi-card" style="--accent:#28d17c" (click)="setTableFilter('moving')">
      <div class="kpi-icon">➤</div>
      <div class="kpi-value">{{ kpi?.MovingVehicles ?? 0 }}</div>
      <div class="kpi-label">در حرکت</div>
    </div>
    <div class="kpi-card" style="--accent:#3d9cff" (click)="setTableFilter('charging')">
      <div class="kpi-icon">⚡</div>
      <div class="kpi-value">{{ kpi?.ChargingVehicles ?? 0 }}</div>
      <div class="kpi-label">در حال شارژ</div>
    </div>
    <div class="kpi-card" style="--accent:#26c6da" (click)="setTableFilter('ready')">
      <div class="kpi-icon">✓</div>
      <div class="kpi-value">{{ kpi?.ReadyVehicles ?? 0 }}</div>
      <div class="kpi-label">آماده حرکت</div>
    </div>
    <div class="kpi-card" style="--accent:#9b7cff">
      <div class="kpi-icon">🔋</div>
      <div class="kpi-value">{{ (kpi?.AverageSOC ?? batteryStats?.AverageSOC ?? 0) | number:'1.1-1' }}%</div>
      <div class="kpi-label">میانگین SOC</div>
    </div>
    <div class="kpi-card" style="--accent:#ff5364" (click)="setTableFilter('warning')">
      <div class="kpi-icon">⚠</div>
      <div class="kpi-value">{{ kpi?.AttentionVehicles ?? attentionVehicles.length }}</div>
      <div class="kpi-label">نیازمند توجه</div>
    </div>
  </section>

  <!-- ───────── MAP + BATTERY ───────── -->
  <section class="grid-2">
    <!-- MAP -->
    <div class="card">
      <div class="card-header">
        <div>
          <div class="card-title">موقعیت لحظه‌ای ناوگان</div>
          <div class="card-subtitle">آخرین موقعیت دریافت‌شده از خودروها — {{ mapVehiclesCount }} خودرو</div>
        </div>
      </div>
      <div class="map-wrapper">
        <div class="map-filter">
          <button [class.active]="mapFilter==='all'" (click)="setMapFilter('all')">همه</button>
          <button [class.active]="mapFilter==='moving'" (click)="setMapFilter('moving')">در حرکت</button>
          <button [class.active]="mapFilter==='charging'" (click)="setMapFilter('charging')">شارژ</button>
          <button [class.active]="mapFilter==='ready'" (click)="setMapFilter('ready')">آماده</button>
          <button [class.active]="mapFilter==='off'" (click)="setMapFilter('off')">خاموش</button>
          <button [class.active]="mapFilter==='warning'" (click)="setMapFilter('warning')">هشدار</button>
        </div>
        <div id="fleetMap"></div>
      </div>
    </div>

    <!-- BATTERY -->
    <div class="card">
      <div class="card-header">
        <div>
          <div class="card-title">وضعیت باتری ناوگان</div>
          <div class="card-subtitle">وضعیت کلی باتری خودروها</div>
        </div>
      </div>
      <div class="card-body">
        <div class="battery-summary">
          <div class="mini-stat">
            <div class="mini-stat-label">میانگین SOC</div>
            <div class="mini-stat-value">{{ (batteryStats?.AverageSOC ?? 0) | number:'1.1-1' }}%</div>
            <div class="progress"><div class="progress-bar" [style.width.%]="batteryStats?.AverageSOC || 0" style="background:#3d9cff"></div></div>
          </div>
          <div class="mini-stat">
            <div class="mini-stat-label">میانگین SOH</div>
            <div class="mini-stat-value">{{ (batteryStats?.AverageSOH ?? 0) | number:'1.1-1' }}%</div>
            <div class="progress"><div class="progress-bar" [style.width.%]="batteryStats?.AverageSOH || 0" style="background:#28d17c"></div></div>
          </div>
          <div class="mini-stat">
            <div class="mini-stat-label">SOC پایین (&lt;20%)</div>
            <div class="mini-stat-value">{{ batteryStats?.LowSOCVehicles ?? 0 }}</div>
          </div>
          <div class="mini-stat">
            <div class="mini-stat-label">نیازمند بررسی باتری</div>
            <div class="mini-stat-value">{{ batteryStats?.BatteryReviewVehicles ?? 0 }}</div>
          </div>
        </div>

        <div class="soc-dist-title">توزیع SOC ناوگان</div>
        <div class="soc-bars">
          <div class="soc-bar-wrap" *ngFor="let val of socDistribution">
            <div class="soc-bar" [style.height.%]="maxSocBucket ? (val / maxSocBucket * 90) : 5">
              <div class="soc-bar-value">{{ val }}</div>
            </div>
          </div>
        </div>
        <div class="soc-labels">
          <div>0-20</div><div>20-40</div><div>40-60</div><div>60-80</div><div>80-100</div>
        </div>
      </div>
    </div>
  </section>

  <!-- ───────── ENERGY + PERFORMANCE + CHARGING ───────── -->
  <section class="grid-3">
    <!-- ENERGY -->
    <div class="card">
      <div class="card-header">
        <div>
          <div class="card-title">وضعیت انرژی و عملکرد</div>
          <div class="card-subtitle">مقادیر لحظه‌ای باتری ناوگان</div>
        </div>
      </div>
      <div class="card-body">
        <div class="energy-grid">
          <div class="energy-box">
            <div class="energy-icon">⚡</div>
            <div class="energy-label">میانگین توان باتری</div>
            <div class="energy-value">— <small>kW</small></div>
          </div>
          <div class="energy-box">
            <div class="energy-icon">🔋</div>
            <div class="energy-label">میانگین ولتاژ باتری</div>
            <div class="energy-value">— <small>V</small></div>
          </div>
          <div class="energy-box">
            <div class="energy-icon">↕</div>
            <div class="energy-label">میانگین جریان باتری</div>
            <div class="energy-value">— <small>A</small></div>
          </div>
          <div class="energy-box">
            <div class="energy-icon">◉</div>
            <div class="energy-label">میانگین ظرفیت باقی‌مانده</div>
            <div class="energy-value">— <small>%</small></div>
          </div>
        </div>
      </div>
    </div>

    <!-- PERFORMANCE -->
    <div class="card">
      <div class="card-header">
        <div>
          <div class="card-title">عملکرد خودروها</div>
          <div class="card-subtitle">وضعیت لحظه‌ای حرکت</div>
        </div>
      </div>
      <div class="card-body">
        <div class="performance-center">
          <div class="speed-value">{{ avgSpeed | number:'1.1-1' }}</div>
          <div class="speed-unit">km/h میانگین سرعت</div>
        </div>
        <div class="metric-row"><span class="metric-name">خودروهای در حال حرکت</span><strong>{{ kpi?.MovingVehicles ?? 0 }}</strong></div>
        <div class="metric-row"><span class="metric-name">خودروهای متوقف</span><strong>{{ (kpi?.TotalVehicles ?? vehicles.length) - (kpi?.MovingVehicles ?? 0) }}</strong></div>
        <div class="metric-row"><span class="metric-name">میانگین شتاب‌دهنده</span><strong>—</strong></div>
        <div class="gear-grid">
          <div class="gear"><strong>0</strong><span>D</span></div>
          <div class="gear"><strong>0</strong><span>R</span></div>
          <div class="gear"><strong>{{ kpi?.TotalVehicles ?? vehicles.length }}</strong><span>N</span></div>
        </div>
      </div>
    </div>

    <!-- CHARGING -->
    <div class="card">
      <div class="card-header">
        <div>
          <div class="card-title">وضعیت شارژ</div>
          <div class="card-subtitle">وضعیت فعلی شارژ خودروها</div>
        </div>
      </div>
      <div class="card-body">
        <div class="charging-status">
          <div class="charge-item"><div class="charge-number">{{ kpi?.ChargingVehicles ?? 0 }}</div><div class="charge-label">در حال شارژ</div></div>
          <div class="charge-item"><div class="charge-number">0</div><div class="charge-label">شارژ تکمیل‌شده</div></div>
          <div class="charge-item"><div class="charge-number">{{ (kpi?.TotalVehicles ?? vehicles.length) - (kpi?.ChargingVehicles ?? 0) }}</div><div class="charge-label">متصل نیست</div></div>
          <div class="charge-item"><div class="charge-number">0</div><div class="charge-label">مشکل شارژ</div></div>
        </div>
        <div class="metric-row" style="margin-top:16px">
          <span class="metric-name">میانگین SOC خودروهای در حال شارژ</span>
          <strong>{{ 0 | number:'1.1-1' }}%</strong>
        </div>
      </div>
    </div>
  </section>

  <!-- ───────── ATTENTION + HEALTH ───────── -->
  <section class="grid-2">
    <div class="card">
      <div class="card-header">
        <div>
          <div class="card-title">خودروهای نیازمند توجه</div>
          <div class="card-subtitle">مهم‌ترین موارد نیازمند بررسی</div>
        </div>
      </div>
      <div class="card-body">
        <div class="attention-grid">
          <div class="attention-box"><div class="attention-count" style="color:#ff5364">{{ getAttentionCount('battery') }}</div><div class="attention-title">مشکل باتری</div></div>
          <div class="attention-box"><div class="attention-count" style="color:#ff8a3d">{{ getAttentionCount('thermal') }}</div><div class="attention-title">مشکل حرارتی</div></div>
          <div class="attention-box"><div class="attention-count" style="color:#f5bd41">0</div><div class="attention-title">مشکل شارژ</div></div>
          <div class="attention-box"><div class="attention-count" style="color:#9b7cff">0</div><div class="attention-title">سایر فنی</div></div>
        </div>
        <table class="alert-table">
          <thead><tr><th>زمان</th><th>خودرو</th><th>مشکل</th><th>شدت</th></tr></thead>
          <tbody>
            <tr *ngFor="let a of attentionVehicles">
              <td>{{ a.dtLastCANUpdate | slice:0:19 }}</td>
              <td>{{ a.strFullName }}</td>
              <td>{{ a.AttentionReason || 'نیازمند بررسی' }}</td>
              <td><span class="health-danger">زیاد</span></td>
            </tr>
            <tr *ngIf="!attentionVehicles.length">
              <td colspan="4" class="empty-cell">در حال حاضر رویداد نیازمند توجهی وجود ندارد</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <div>
          <div class="card-title">سلامت فنی ناوگان</div>
          <div class="card-subtitle">خلاصه وضعیت باتری و سیستم‌های فنی</div>
        </div>
      </div>
      <div class="card-body">
        <div class="health-score">
          <div class="health-circle" [style.background]="'radial-gradient(circle at center, #151c25 58%, transparent 59%), conic-gradient(#28d17c 0 ' + ((batteryStats?.AverageSOH || 94) | number:'1.0-0') + '%, #26313d ' + ((batteryStats?.AverageSOH || 94) | number:'1.0-0') + '% 100%)'">
            {{ (batteryStats?.AverageSOH || 0) | number:'1.0-0' }}%
          </div>
          <div class="health-list">
            <div class="health-item"><span>میانگین SOH</span><strong>{{ (batteryStats?.AverageSOH || 0) | number:'1.1-1' }}%</strong></div>
            <div class="health-item"><span>باتری نیازمند بررسی</span><strong>{{ batteryStats?.BatteryReviewVehicles ?? 0 }}</strong></div>
            <div class="health-item"><span>دمای غیرعادی (&gt;50°)</span><strong>{{ getAttentionCount('thermal') }}</strong></div>
            <div class="health-item"><span>اختلاف سلولی</span><strong>0</strong></div>
            <div class="health-item"><span>مشکل خنک‌کاری</span><strong>0</strong></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ───────── VEHICLE TABLE (scrollable, no pagination) ───────── -->
  <section class="card table-card">
    <div class="card-header">
      <div>
        <div class="card-title">خودروهای ناوگان</div>
        <div class="card-subtitle">وضعیت لحظه‌ای تمام خودروها — {{ filteredVehicles.length }} خودرو</div>
      </div>
      <div class="table-toolbar">
        <input type="text" class="search-box" placeholder="جستجوی خودرو، پلاک، VIN، UnitID..." [(ngModel)]="searchTerm">
        <button class="filter-btn" [class.active]="tableFilter==='all'" (click)="setTableFilter('all')">همه</button>
        <button class="filter-btn" [class.active]="tableFilter==='moving'" (click)="setTableFilter('moving')">در حرکت</button>
        <button class="filter-btn" [class.active]="tableFilter==='charging'" (click)="setTableFilter('charging')">شارژ</button>
        <button class="filter-btn" [class.active]="tableFilter==='ready'" (click)="setTableFilter('ready')">آماده</button>
        <button class="filter-btn" [class.active]="tableFilter==='off'" (click)="setTableFilter('off')">خاموش</button>
        <button class="filter-btn" [class.active]="tableFilter==='warning'" (click)="setTableFilter('warning')">توجه</button>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="table-scroll">
        <table class="vehicle-table">
          <thead>
            <tr>
              <th>خودرو</th>
              <th>پلاک</th>
              <th>وضعیت</th>
              <th>سرعت</th>
              <th>SOC</th>
              <th>SOH</th>
              <th>ولتاژ سلول</th>
              <th>دما (max)</th>
              <th>وضعیت فنی</th>
              <th>آخرین ارتباط</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let v of filteredVehicles; trackBy: trackByUnitId" (click)="viewDetails(v)">
              <td>
                <div class="vehicle-name">{{ v.strFullName }}</div>
                <div class="vehicle-sub">{{ v.strUnitID }}</div>
              </td>
              <td><span class="plate-badge">{{ v.strVehicleNo }}</span></td>
              <td><span class="status" [ngClass]="getStatusClass(v)"><span>●</span> {{ getStatusTitle(v) }}</span></td>
              <td>{{ v.VehicleSpeed != null ? v.VehicleSpeed : '—' }} <small *ngIf="v.VehicleSpeed != null">km/h</small></td>
              <td><strong>{{ v.BatterySOC != null ? (v.BatterySOC | number:'1.1-1') + '%' : '—' }}</strong></td>
              <td [ngClass]="getSohClass(v.BatterySOH)">{{ v.BatterySOH != null ? (v.BatterySOH | number:'1.1-1') + '%' : '—' }}</td>
              <td>{{ v.MaxBatteryCellVoltage != null ? (v.MaxBatteryCellVoltage | number:'1.2-2') + ' V' : '—' }}</td>
              <td>{{ v.MaxCellTemperature != null ? v.MaxCellTemperature + ' °C' : '—' }}</td>
              <td>
                <span *ngIf="!v.NeedsAttention" class="health-good">● سالم</span>
                <span *ngIf="v.NeedsAttention" class="health-danger">● {{ v.AttentionReason || 'نیازمند توجه' }}</span>
              </td>
              <td class="ltr-text">{{ v.dtLastCANUpdate | slice:0:19 }}</td>
              <td>
                <button class="detail-btn" (click)="viewDetails(v); $event.stopPropagation()">مشاهده جزئیات خودرو</button>
              </td>
            </tr>
            <tr *ngIf="!filteredVehicles.length">
              <td colspan="11" class="empty-cell">خودرویی با این فیلتر یافت نشد</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

  <!-- ───────── EVENTS ───────── -->
  <section class="card events-card">
    <div class="card-header">
      <div>
        <div class="card-title">آخرین رویدادها</div>
        <div class="card-subtitle">رویدادهای اخیر ناوگان (نیازمند توجه)</div>
      </div>
    </div>
    <div class="card-body">
      <table class="events-table">
        <thead><tr><th>زمان</th><th>خودرو</th><th>رویداد</th><th>شدت</th><th>وضعیت</th></tr></thead>
        <tbody>
          <tr *ngFor="let e of attentionVehicles | slice:0:5">
            <td>{{ e.dtLastCANUpdate | slice:0:19 }}</td>
            <td>{{ e.strFullName }}</td>
            <td>{{ e.AttentionReason || 'نیازمند بررسی' }}</td>
            <td><span class="health-danger">زیاد</span></td>
            <td>جدید</td>
          </tr>
          <tr *ngIf="!attentionVehicles.length">
            <td colspan="5" class="empty-cell">رویداد جدیدی ثبت نشده است</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

</div>
